import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
 
const router = new VueRouter({
  mode: 'hash', // 使用 hash 模式
  routes: [
    {
      path: '/',
      name: 'InvoiceDecoder',
      component: () => import('@/views/invoiceDecoder/index.vue')
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/views/Home/index.vue')
    },
    {
      path: '/faceRecog',
      name: 'FaceRecog',
      component: () => import('@/views/faceRecog/index.vue')
    },
    {
      path: '/map',
      name: 'Map',
      component: () => import('@/views/map/index.vue')
    },
    {
      path: '/face',
      name: 'Face',
      component: () => import('@/views/face/index.vue')
    },
    {
      path: '/chooseLocation',
      name: 'ChooseLocation',
      component: () => import('@/views/chooseLocation/index.vue')
    },
    {
      path: '/certificate',
      name: 'Certificate',
      component: () => import('@/views/certificate/index.vue')
    },
    {
      path: '/graphVisual',
      name: 'GraphVisual',
      component: () => import('@/views/graphVisual/index.vue')
    }
  ]
});
 
export default router;